/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MaskedInput from 'react-text-mask';
import { object, bool, string, func, number, PropTypes } from 'prop-types';

// MUI
import {
    Grid, FormControl, InputLabel, Select, Checkbox, FormHelperText, TextField, Divider
} from '@material-ui/core';

// Helpers
import { monthsMM, days, years } from '../../Helpers/Helpers';
import { getUserProfile } from '../../../../../../../../../state/ducks/Checkout/ducks/Common/Common-Selectors';

// Styles
import { CommonStyles } from '../../../../../../style/commonStyles';

/* eslint-disable react/jsx-props-no-spreading */
const AddOccasionsForm = ({
    classes, showDivider, occasion, index, holidayOccasion, parentComponent, getStatusOfSwitch, methods
}) => {
    const useCommonStyles = CommonStyles();
    const userProfile = useSelector(getUserProfile) || {};
    const { email = '' } = userProfile;
    const dateDDFieldName = `occasions[${index}].dateDD`;
    const dateMMFieldName = `occasions[${index}].dateMM`;
    const dateYYYYFieldName = `occasions[${index}].dateYYYY`;
    const watchOccasions = methods?.watch('occasions');

    const [editPhone, setEditPhone] = useState(false);
    const [daysAsPerMonth, setDaysAsPerMonth] = useState(days(occasion?.dateMM));
    const [isCheckboxClicked, setIsCheckboxClicked] = useState(false);
    const {
        setValue, formState: { errors }, register, clearErrors,
    } = methods;

    const handleSelectChange = (event, occ, source = '') => {
        const selectedValue = `${event.target.value}` || event.target.checked;
         // Check if the change event originated from the switch
        if (source !== 'switch') {
            setValue(`${source}`, selectedValue);
            return;
        }

        if (index !== -1) {
            // Update occasion details for the selected occasion
            setValue(`occasions[${index}].${event.target.name}`, selectedValue);
            setIsCheckboxClicked(!isCheckboxClicked);
        }
    };

    const handleCheckboxChange = (e) => {
        const targetCheckboxName = e.target.name
        if (typeof handleSelectChange === 'function') {
            handleSelectChange(e, occasion, targetCheckboxName);
        }
        setIsCheckboxClicked(!isCheckboxClicked);
    };
    
    useEffect(() => {
        if (!watchOccasions[index]?.reminderPhone || watchOccasions[index]?.reminderPhone === '') {
            setEditPhone(true);
        }
    }, [])

    const handleMonthChange = (e) => {
        clearErrors(`occasions`);
        setDaysAsPerMonth(days(e.target.value));
        if (watchOccasions?.[index]?.dateDD !== '' && days(e.target.value).indexOf(watchOccasions?.[index]?.dateDD) === -1) {
            methods?.resetField(dateDDFieldName);
        };
    };

    const handleDayChange = (e) => {
      clearErrors(`occasions`);
    };

    return (
        <div className={useCommonStyles.addOccasionStyle}>
            {!holidayOccasion && (parentComponent !== 'DesktopAddNewRecipient' || parentComponent !== 'AddNewRecipient') && (
                <Grid container spacing={3} style={{ marginTop: '20px' }}>
                    <Grid item xs={4}>
                        <FormControl variant="filled" fullWidth sx={{ m: 1 }}>
                            <InputLabel id="month-label">Month</InputLabel>
                            <Select
                                name="dateMM"
                                onChange={handleSelectChange}
                                labelId="month-label"
                                variant="filled"
                                native
                                defaultValue={occasion?.dateMM || ''}
                                {...register(dateMMFieldName, {
                                    onChange: (e) => {handleMonthChange(e)}
                                })}
                            >
                                <option value="" disabled={parentComponent === 'DesktopAddNewRecipient' || parentComponent === 'AddNewRecipient' ? false : true} />
                                {Object.entries(monthsMM).map(([monthName, monthNumber]) => (
                                    <option key={monthNumber} value={monthNumber}>
                                        {monthName}
                                    </option>
                                ))}
                            </Select>
                            {errors.occasions?.[index]?.message?.includes('Month') ? (
                                <FormHelperText style={{
                                    fontSize: '12px', color: 'red', marginLeft: '0px',
                                }}
                                >{errors.occasions?.[index]?.message}
                                </FormHelperText>
                            ) : null}
                        </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                        <FormControl variant="filled" fullWidth sx={{ m: 1 }}>
                            <InputLabel id="day-label">Day</InputLabel>
                            <Select
                                name="dateDD"
                                onChange={handleSelectChange}
                                labelId="day-label"
                                variant="filled"
                                native
                                defaultValue={occasion?.dateDD || ''}
                                {...register(dateDDFieldName, {
                                    onChange: (e) => {handleDayChange(e)}
                                })}
                            >
                                <option value="" disabled={parentComponent === 'DesktopAddNewRecipient' || parentComponent === 'AddNewRecipient' ? false : true}/>
                                {daysAsPerMonth.map((day) => (
                                    <option key={day} value={day}>
                                        {day}
                                    </option>
                                ))}
                            </Select>
                            {errors.occasions?.[index]?.message?.includes('Day') ? (
                                <FormHelperText style={{
                                    fontSize: '12px', color: 'red', marginLeft: '0px',
                                }}
                                >{errors?.occasions?.[index]?.message}
                                </FormHelperText>
                            ) : null}
                        </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                        <FormControl variant="filled" className={classes.yearFormField} fullWidth sx={{ m: 1 }}>
                            <InputLabel id="year-label">
                                Year <span style={{ fontSize: '10px' }}>(optional)</span>
                            </InputLabel>
                            <Select
                                name="dateYYYY"
                                onChange={handleSelectChange}
                                labelId="year-label"
                                variant="filled"
                                native
                                defaultValue={occasion?.dateYYYY || ''}
                                {...register(dateYYYYFieldName)}
                            >
                                <option value="" disabled />
                                {years.map((year) => (
                                    <option key={year} value={year} style={{ minHeight: '48px' }}>
                                        {year}
                                    </option>
                                ))}
                            </Select>
                            {errors.occasions?.[index]?.message?.includes('Year') ? (
                                <FormHelperText style={{
                                    fontSize: '12px', color: 'red', marginLeft: '0px',
                                }}
                                >{errors?.occasions?.[index]?.message}
                                </FormHelperText>
                            ) : null}
                        </FormControl>
                    </Grid>
                </Grid>
            )}
            <div className={classes.hidePreferences}>
                <div className={classes.reminderContainer}>
                    <h4 style={{ margin: '12px 0px' }}>I want to receive my reminders by</h4>
                    <Grid container item xs={12}>
                        <Grid container item xs={12} className={classes.subscribeContainer}>
                            <Grid item>
                                <Checkbox
                                    name="subscribedPhone"
                                    icon={<span className={classes.customCheckbox} />}
                                    checkedIcon={<span className={classes.customCheckedCheckbox} />}
                                    color="primary"
                                    classes={{ root: classes.facetsCheckbox }}
                                    checked={watchOccasions?.[index]?.subscribedPhone || false}
                                    {...register(`occasions[${index}].subscribedPhone`)}
                                    onChange={handleCheckboxChange}
                                />
                                {occasion?.reminderPhone?.length === 14 ? `SMS (Tel: ${occasion?.reminderPhone})` : 'SMS'}
                                {(!editPhone && watchOccasions?.[index]?.reminderPhone !== '' && watchOccasions?.[index]?.reminderPhone) && <button type="button" className={classes.editBtn} onClick={() => setEditPhone(true)} style={{ marginLeft: '10px', borderRadius: '0px', float: 'none', cursor: 'pointer' }}>Edit</button>}
                            </Grid>
                            {editPhone
                                && (<Grid item>
                                        <FormControl variant="filled" fullWidth>
                                            {/* Tried to use TextFieldHelper here but logic for occasions error is different and getting issue for the field name hence creating separate text field is best option for now */}
                                            <TextField
                                                id="reminderPhone"
                                                type="text"
                                                variant="filled"
                                                fullWidth
                                                label="Mobile number"
                                                required={watchOccasions?.[index]?.subscribedPhone}
                                                defaultValue={watchOccasions?.[index]?.reminderPhone}
                                                disabled={!watchOccasions[index].subscribedPhone}
                                                {...register(`occasions[${index}].reminderPhone`)}
                                                style={{ marginBottom: errors?.occasions?.[index]?.reminderPhone?.message ? '0px' : '20px' }}
                                                InputProps={{
                                                    inputComponent: MaskedInput,
                                                    inputProps: {
                                                        mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/,],
                                                        guide: true,
                                                    },
                                                }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            {(errors?.occasions?.[index]?.reminderPhone?.message) ? (
                                                <FormHelperText style={{
                                                    fontSize: '12px', color: 'red',
                                                }}
                                                >{errors.occasions[index].reminderPhone.message}
                                                </FormHelperText>
                                            ) : null}
                                        </FormControl>
                                    </Grid>)
                            }
                        </Grid>
                        <Grid item xs={12}>
                            <Checkbox
                                name="subscribedEmail"
                                icon={<span className={classes.customCheckbox} />}
                                checkedIcon={<span className={classes.customCheckedCheckbox} />}
                                color="primary"
                                checked={watchOccasions?.[index]?.subscribedEmail || false}
                                classes={{ root: classes.facetsCheckbox }}
                                {...register(`occasions[${index}].subscribedEmail`)}
                                onChange={handleCheckboxChange}
                            />
                            {`E-mail (${email})`}
                        </Grid>
                    </Grid>
                </div>
            </div>
            {showDivider && <Divider className={classes.divider} />}
        </div>
    );
};

AddOccasionsForm.propTypes = {
    parentComponent: string,
    index: number.isRequired,
    classes: object.isRequired,
    methods: object.isRequired,
    occasion: PropTypes.shape({
        dateDD: string,
        dateMM: string,
        dateYYYY: string,
        desc: string,
        occasion: string,
        occasionId: string,
        reminderEmail: string,
        reminderPhone: string,
        subscribed: bool,
        subscribedEmail: bool,
        subscribedPhone: bool,
    }),
    showDivider: bool.isRequired,
    holidayOccasion: bool.isRequired,
    getStatusOfSwitch: func.isRequired,
};

export default AddOccasionsForm;
